export default "__VITE_ASSET__b0cc7250__"